import React from "react";
import PageTitle from "./PageTitle/PageTitle";
export default function UHeader({ title, goBack, right, align = "center" }) {
  return (
    <div
      style={{ height: "60px", textAlign: "left" }}
      className={`uk-width-1-1 uk-padding-small uk-background-default mb-2 uk-flex uk-flex-middle ${align === "left" ? "uk-flex-between" : "uk-flex-between"}`}
    >
      <div className="uk-flex uk-flex-middle" style={{ gap: 8 }}>
        {goBack && (
          <span
            className="pointer"
            uk-icon="icon:chevron-left;ratio: 1.5"
            onClick={goBack}
          />
        )}
        {align === "left" && <PageTitle title={title} />}
      </div>
      {align !== "left" && (
        <div className="uk-text-center">
          <PageTitle title={title} />
        </div>
      )}
      <div>{right && right}</div>
    </div>
  );
}
//
